import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Import translation files
import enCommon from './locales/en/common.json';
import enApp from './locales/en/app.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enForms from './locales/en/forms.json';
import enNavigation from './locales/en/navigation.json';
import enBooking from './locales/en/booking.json';
import enProfile from './locales/en/profile.json';
import enAdmin from './locales/en/admin.json';
import enErrors from './locales/en/errors.json';
import enReceptionist from './locales/en/receptionist.json';
import enNotifications from './locales/en/notifications.json';
import enPublicPlans from './locales/en/publicPlans.json';
import enPlanSelector from './locales/en/planSelector.json';
import enPlanDetails from './locales/en/planDetails.json';
import enSportsDiary from './locales/en/sportsDiary.json';
import enMyBookings from './locales/en/myBookings.json';
import enTrainerProfile from './locales/en/trainerProfile.json';
import enFacilities from './locales/en/facilities.json';
import enClasses from './locales/en/classes.json';
import enClassType from './locales/en/classType.json';
import enPhysicalMeasurement from './locales/en/physicalMeasurement.json';
import enScheduledClass from './locales/en/scheduledClass.json';
import enGallery from './locales/en/gallery.json';
import enPayment from './locales/en/payment.json';
import enRegistrationStatus from './locales/en/registrationStatus.json';
import enRegistration from './locales/en/registration.json';
import enKvkk from './locales/en/kvkk.json';
import enEmailVerification from './locales/en/emailVerification.json';
import enActivityLogs from './locales/en/activityLogs.json';

import trCommon from './locales/tr/common.json';
import trApp from './locales/tr/app.json';
import trAuth from './locales/tr/auth.json';
import trDashboard from './locales/tr/dashboard.json';
import trForms from './locales/tr/forms.json';
import trNavigation from './locales/tr/navigation.json';
import trBooking from './locales/tr/booking.json';
import trProfile from './locales/tr/profile.json';
import trAdmin from './locales/tr/admin.json';
import trErrors from './locales/tr/errors.json';
import trReceptionist from './locales/tr/receptionist.json';
import trNotifications from './locales/tr/notifications.json';
import trPublicPlans from './locales/tr/publicPlans.json';
import trPlanSelector from './locales/tr/planSelector.json';
import trPlanDetails from './locales/tr/planDetails.json';
import trSportsDiary from './locales/tr/sportsDiary.json';
import trMyBookings from './locales/tr/myBookings.json';
import trTrainerProfile from './locales/tr/trainerProfile.json';
import trFacilities from './locales/tr/facilities.json';
import trClasses from './locales/tr/classes.json';
import trClassType from './locales/tr/classType.json';
import trPhysicalMeasurement from './locales/tr/physicalMeasurement.json';
import trScheduledClass from './locales/tr/scheduledClass.json';
import trGallery from './locales/tr/gallery.json';
import trPayment from './locales/tr/payment.json';
import trRegistrationStatus from './locales/tr/registrationStatus.json';
import trRegistration from './locales/tr/registration.json';
import trKvkk from './locales/tr/kvkk.json';
import trEmailVerification from './locales/tr/emailVerification.json';
import trActivityLogs from './locales/tr/activityLogs.json';

const resources = {
  en: {
    common: enCommon,
    app: enApp,
    auth: enAuth,
    dashboard: enDashboard,
    forms: enForms,
    navigation: enNavigation,
    booking: enBooking,
    profile: enProfile,
    admin: enAdmin,
    errors: enErrors,
    receptionist: enReceptionist,
    notifications: enNotifications,
    publicPlans: enPublicPlans,
    planSelector: enPlanSelector,
    planDetails: enPlanDetails,
    sportsDiary: enSportsDiary,
    myBookings: enMyBookings,
    trainerProfile: enTrainerProfile,
    facilities: enFacilities,
    classes: enClasses,
    classType: enClassType,
    physicalMeasurement: enPhysicalMeasurement,
    scheduledClass: enScheduledClass,
    gallery: enGallery,
    payment: enPayment,
    registrationStatus: enRegistrationStatus,
    registration: enRegistration,
    kvkk: enKvkk,
    emailVerification: enEmailVerification,
    activityLogs: enActivityLogs,
  },
  tr: {
    common: trCommon,
    app: trApp,
    auth: trAuth,
    dashboard: trDashboard,
    forms: trForms,
    navigation: trNavigation,
    booking: trBooking,
    profile: trProfile,
    admin: trAdmin,
    errors: trErrors,
    receptionist: trReceptionist,
    notifications: trNotifications,
    publicPlans: trPublicPlans,
    planSelector: trPlanSelector,
    planDetails: trPlanDetails,
    sportsDiary: trSportsDiary,
    myBookings: trMyBookings,
    trainerProfile: trTrainerProfile,
    facilities: trFacilities,
    classes: trClasses,
    classType: trClassType,
    physicalMeasurement: trPhysicalMeasurement,
    scheduledClass: trScheduledClass,
    gallery: trGallery,
    payment: trPayment,
    registrationStatus: trRegistrationStatus,
    registration: trRegistration,
    kvkk: trKvkk,
    emailVerification: trEmailVerification,
    activityLogs: trActivityLogs,
  },
};

i18n
  // Load translation using http backend
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Use local resources instead of http backend for now
    resources,
    
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Default namespace
    defaultNS: 'common',
    
    // Namespace separator
    nsSeparator: ':',
    
    // Key separator
    keySeparator: '.',

    // React specific options
    react: {
      useSuspense: false,
    },
  });

export default i18n;